// Module
var code = "<div id=\"V-CF374E4B-757A-43C1-A4FE-5F6111B9B69A\"> <div> <div data-b-component=\"content\" data-b-comp-content=\"{Binding selector}\"></div> </div> </div> ";
// Exports
export default code;